/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
const develop = false;
// const develop = true;

export default {
  // test server                                        production server
  server_url: develop
    ? "https://api.joonaakhub.com/"
    : "https://api.joonaakhub.com/",
  ws_server_url: develop
    ? "ws://api.joonaakhub.com/"
    : "ws://api.joonaakhub.com/",
  spring_url_base: develop
    // ? "http://localhost:8882/api/v1/"
    ? "https://hubapidev.joonaakhub.com/api/v1/"
    : "https://hubapi.joonaakhub.com/api/v1/",

  spring_cc_url_base: "https://ccapi.joonaakhub.com/api/v1/",

  basic_header: "Basic Sk5UcnVzdDpKTlNlY3JldA==",
  env: "development",
  telegram_listener: "https://listener.joonaakhub.com/hub_status_change",
  googleMapKey: "AIzaSyBnx4Lu8Tn-dTiZxQ9UuNZrH4ko0aXR2KQ",
  telegramBotToken: "1044598367:AAGyqdY94JahxqHozcCrau9T0BfrLsF3y6I",
  // notification
  push_notification_url: develop
    ? "https://notification.joonaakhub.com/"
    : "https://notification.joonaakhub.com/",
  dev_mode: develop,
  app_version: `3.5.1${develop ? ' dev' : ''}`
};
